angular.module('ib-check-in-confirmation-module', [
    'ib-rental-car-module',
    'ib-biometric-boarding-box-module',
    'ib-digital-boarding-box-module',
    'ib-pmt-confirmation-carbon-footprint-module'
]);